import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import logger from "../Utils/logger";

export const useWebSocket = () => {
  const [wsData, setWsData] = useState(null);
  const wsRef = useRef(null);
  const navigate = useNavigate();

  const startWebSocket = (url, onMessageCallback) => {
    wsRef.current = new WebSocket(url);

    wsRef.current.onopen = () => {
      logger.log("[websocket] connected:", url);
    };

    wsRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      logger.log("[websocket] message received:", data);
      setWsData(data);
      localStorage.setItem("websocketRes", JSON.stringify(data));

      if (onMessageCallback) {
        onMessageCallback(data, navigate);
      }
    };

    wsRef.current.onclose = () => {
      logger.log("[websocket] disconnected:", url);
    };

    wsRef.current.onerror = (err) => {
      logger.error("[websocket] error:", err);
      wsRef.current.close();
    };
  };

  const stopWebSocket = () => {
    if (wsRef.current) wsRef.current.close();
  };

  return { wsData, startWebSocket, stopWebSocket };
};
